import type { ReactNode } from "react";
import { ChevronLeft } from "lucide-react";
import { CheckoutTerms } from "./CheckoutTerms";
import { useOptionalParticipationFlow } from "~/components/participation/ParticipationFlow";

export function CheckoutFooter({ children, onBack, backDisabled = false, error, showTerms = true, widePrimary = false }: { children: ReactNode; onBack?: () => void; backDisabled?: boolean; error?: string | null; showTerms?: boolean; widePrimary?: boolean }) {
  const flow = useOptionalParticipationFlow();
  return (
    <div className="relative bottom-0 z-10 -mx-6 -mb-6 mt-auto shrink-0 border-t border-butter-cream bg-butter-cream-light px-6 pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:sticky sm:mt-6 sm:rounded-b-[20px] sm:pb-3">
      {error && <p role="alert" className="mb-3 font-sans text-sm text-butter-pink">{error}</p>}

      <div className={`grid items-center gap-3 ${onBack ? widePrimary ? "grid-cols-[1fr_3fr]" : "grid-cols-2" : "grid-cols-1"}`}>
        {onBack && (
          <button type="button" onClick={onBack} disabled={backDisabled || flow?.pending?.blocksNavigation} className="flex h-12 min-w-0 items-center justify-start gap-1 rounded-sm font-sans text-sm font-bold text-butter-green hover:opacity-70 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-butter-green disabled:opacity-40">
            <ChevronLeft className="size-4" aria-hidden="true" />
            Back
          </button>
        )}
        <div className="min-w-0 [&>button]:h-12 [&>button]:py-1! [&>button]:text-sm! [&>button]:font-bold [&>a]:h-12 [&>a]:py-1! [&>a]:text-sm! [&>a]:font-bold">{children}</div>
      </div>
      {showTerms && <CheckoutTerms className="mt-3" />}
    </div>
  );
}
